import { createContext, useEffect, useState, useContext } from "react";
import { UserContext } from "./userProvider";
import apiUser from "../apiUser";
import { MOTIVOS } from "../constants/motivos";

export const PatrimonioContext = createContext();

export const PatrimonioProvider = ({ children }) => {
  const { setAlert } = useContext(UserContext);
  const [grupos, setGrupos] = useState([]);
  const [equipamentos, setEquipamentos] = useState([]);
  const [patrimonios, setPatrimonios] = useState([]);
  const [patLoading, setPatLoading] = useState(false);

  const createPatrimonio = async (patrimonio) => {
    try {
      const response = await apiUser.post(`patrimonio/createPatrimonio`, patrimonio);
      const { success, message } = response.data;
      if (success) {
        setAlert({ visible: true, title: "Sucesso!", placeholder: message, confirm: false, type: "success" });
        return true;
      } else {
        setAlert({ visible: true, title: "Atenção!", placeholder: message, confirm: false, type: "warning" });
      }
    } catch (error) {
      console.log(error);
      setAlert({
        type: "error",
        message: "Erro ao criar patrimônio",
      });
    }
  }

  const marcasByFornecedor = async (id) => {
    try {
      const response = await apiUser.post(`patrimonio/marcasByFornecedorId`, { id });
      const { success, message, dados } = response.data;
      if (success) {
        return dados;
      } else {
        setAlert({ visible: true, title: "Atenção!", placeholder: message, confirm: false, type: "warning" });
      }
    } catch (error) {
      setAlert({
        type: "error",
        message: "Erro ao buscar marcas",
      });
    }
  }

  const modelosByMarca = async (id) => {
    try {
      const response = await apiUser.post(`patrimonio/modelosByMarcaId`, { id });
      const { success, message, dados } = response.data;
      if (success) {
        return dados;
      } else {
        setAlert({ visible: true, title: "Atenção!", placeholder: message, confirm: false, type: "warning" });
      }
    } catch (error) {
      console.log(error);
      setAlert({
        type: "error",
        message: "Erro ao buscar modelos",
      });
    }
  }

  const criarMarca = async (marca) => {
    try {
      const response = await apiUser.post(`patrimonio/createMarca`, marca);
      const { success, message } = response.data;
      if (success) {
        setAlert({ visible: true, title: "Sucesso!", placeholder: message, confirm: false, type: "success" });
      } else {
        setAlert({ visible: true, title: "Atenção!", placeholder: message, confirm: false, type: "warning" });
      }
      return success;
    } catch (error) {
      console.log(error);
      setAlert({
        type: "error",
        message: "Erro ao criar marca",
      });
    }
  }

  const criarModelo = async (modelo) => {
    try {
      const response = await apiUser.post(`patrimonio/createModelo`, modelo);
      const { success, message } = response.data;
      if (success) {
        setAlert({ visible: true, title: "Sucesso!", placeholder: message, confirm: false, type: "success" });
      } else {
        setAlert({ visible: true, title: "Atenção!", placeholder: message, confirm: false, type: "warning" });
      }
      return success;
    } catch (error) {
      console.log(error);
      setAlert({
        type: "error",
        message: "Erro ao criar modelo",
      });
    }
  }

  const deleteMarca = async (id) => {
    try {
      const response = await apiUser.post(`patrimonio/deleteMarcaById`, { id });
      const { success, message } = response.data;
      if (success) {
        setAlert({ visible: true, title: "Sucesso!", placeholder: message, confirm: false, type: "success" });
      } else {
        setAlert({ visible: true, title: "Atenção!", placeholder: message, confirm: false, type: "warning" });
      }
      return success;
    } catch (error) {
      console.log(error);
      setAlert({
        type: "error",
        message: "Erro ao deletar marca",
      });
    }
  }

  const deleteModelo = async (id) => {
    try {
      const response = await apiUser.post(`patrimonio/deleteModeloById`, { id });
      const { success, message } = response.data;
      if (success) {
        setAlert({ visible: true, title: "Sucesso!", placeholder: message, confirm: false, type: "success" });
      } else {
        setAlert({ visible: true, title: "Atenção!", placeholder: message, confirm: false, type: "warning" });
      }
      return success;
    } catch (error) {
      console.log(error);
      setAlert({
        type: "error",
        message: "Erro ao deletar modelo",
      });
    }
  }

  const dadosGrupos = async () => {
    try {
      const response = await apiUser.get(`patrimonio/dadosGrupos`);
      const { success, message, dados } = response.data;
      if (success) {
        setGrupos(dados);
        return dados;
      } else {
        setAlert({ visible: true, title: "Atenção!", placeholder: message, confirm: false, type: "warning" });
      }
      return dados;
    } catch (error) {
      console.log(error);
      setAlert({
        type: "error",
        message: "Erro ao buscar grupos",
      });
      return [];
    }
  }


  const criarGrupo = async (grupo) => {
    try {
      const response = await apiUser.post(`patrimonio/createGrupo`, grupo);
      const { success, message } = response.data;
      if (success) {
        setAlert({ visible: true, title: "Sucesso!", placeholder: message, confirm: false, type: "success" });
        dadosGrupos();
      } else {
        setAlert({ visible: true, title: "Atenção!", placeholder: message, confirm: false, type: "warning" });
      }
      return success;
    } catch (error) {
      console.log(error);
      setAlert({
        type: "error",
        message: "Erro ao criar grupo",
      });
    }
  }

  const dadosEquipamentos = async () => {
    try {
      const response = await apiUser.get(`patrimonio/dadosModelos`);
      const { success, message, dados } = response.data;
      if (success) {
        setEquipamentos(dados);
      } else {
        setAlert({ visible: true, title: "Atenção!", placeholder: message, confirm: false, type: "warning" });
      }
    } catch (error) {
      console.log(error);
      setAlert({
        type: "error",
        message: "Erro ao buscar equipamentos",
      });
    }
  }

  const equipamentosByGrupo = async (grupo) => {
    try {
      const response = await apiUser.post(`patrimonio/equipamentosByGrupoId`, grupo);
      const { success, message, dados } = response.data;
      if (success) {
        return dados;
      } else {
        setAlert({ visible: true, title: "Atenção!", placeholder: message, confirm: false, type: "warning" });
      }
    } catch (error) {
      console.log(error);
      setAlert({
        type: "error",
        message: "Erro ao buscar equipamentos",
      });
    }
  }

  const updateGrupoEquipamentos = async (grupo) => {
    try {
      const response = await apiUser.post(`patrimonio/updateEquipamentosByGrupo`, grupo);
      const { success, message } = response.data;
      if (success) {
        setAlert({ visible: true, title: "Sucesso!", placeholder: message, confirm: false, type: "success" });
      } else {
        setAlert({ visible: true, title: "Atenção!", placeholder: message, confirm: false, type: "warning" });
      }
    } catch (error) {
      console.log(error);
      setAlert({
        type: "error",
        message: "Erro ao buscar equipamentos",
      });
      return false;
    }
    finally {
      await dadosGrupos()
      return true;
    }

  }

  const buscarPatrimoniosNfs = async (patrimoniosDados) => {
    setPatLoading(true);
    try {
      const response = await apiUser.post(`patrimonio/buscarPatrimoniosnfs`, patrimoniosDados);
      const { success, message, dados } = response.data;
      if (success) {
        setPatrimonios(dados);
        return true;
      } else {
        setAlert({ visible: true, title: "Atenção!", placeholder: message, confirm: false, type: "warning" });
      }
    } catch (error) {
      console.log(error);
      setPatLoading(false);
      setAlert({
        type: "error",
        message: "Erro ao buscar equipamentos",
      });
    } finally {
      setPatLoading(false);
    }
  }

  const buscarPatrimonios = async (patrimoniosDados) => {
    setPatLoading(true);
    try {
      const response = await apiUser.post(`patrimonio/buscarPatrimonios`, patrimoniosDados);
      const { success, message, dados } = response.data;
      if (success) {
        setPatrimonios(dados);
        return true;
      } else {
        setAlert({ visible: true, title: "Atenção!", placeholder: message, confirm: false, type: "warning" });
      }
    } catch (error) {
      setPatLoading(false);
      console.log(error);
      setAlert({
        type: "error",
        message: "Erro ao buscar equipamentos",
      });
    } finally {
      setPatLoading(false);
    }
  }

  const buscarAllPatrimonios = async (dados) => {
    try {
      const [respPat, respPatNfs] = await Promise.all([
        apiUser.post(`patrimonio/buscarPatrimonios`, dados),
        apiUser.post(`patrimonio/buscarPatrimoniosnfs`, dados)
      ]);
      let patsNfs = [];
      let pats = [];
      if (respPat.data.success) {
        pats = respPat.data.dados.map(pat => {
          return {
            ...pat,
            nfs: false
          }
        })
      }
      if (respPatNfs.data.success) {
        patsNfs = respPatNfs.data.dados.map(pat => {
          return {
            ...pat,
            nEtiqueta: pat.netiqueta,
            nSerie: pat.nserie,
            nMac: pat.nmac,
            nfs: true
          }
        });
      }
      //remoção de etiquetas repetidas
      // pats = pats.filter((pat, index, self) =>
      //   index === self.findIndex((t) => t.nEtiqueta === pat.nEtiqueta)
      // );
      // patsNfs = patsNfs.filter((pat, index, self) =>
      //   index === self.findIndex((t) => t.nEtiqueta === pat.nEtiqueta)
      // );
      let newPats = [...pats, ...patsNfs];
      setPatrimonios(newPats);
      return newPats;
    } catch (error) {
      console.log(error);
    }
  }

  const updatePatrimonioById = async (patrimonio) => {
    try {
      const response = await apiUser.post(`patrimonio/updatePatrimonioById`, patrimonio);
      const { success, message, dados } = response.data;
      if (success) {
        updatePatrimonioState(dados, patrimonios, setPatrimonios);
        setAlert({ visible: true, title: "Sucesso!", placeholder: message, confirm: false, type: "success" });
        return dados;
      } else {
        setAlert({ visible: true, title: "Atenção!", placeholder: message, confirm: false, type: "warning" });
      }
    } catch (error) {
      console.log(error);
      setAlert({
        type: "error",
        message: "Erro ao buscar equipamentos",
      });
    }
  }

  const updatePatrimonioNfsById = async (patrimonio) => {
    try {
      const response = await apiUser.post(`patrimonio/updatePatrimonioNfsById`, patrimonio);
      const { success, message, dados } = response.data;
      if (success) {
        updatePatrimonioState(dados, patrimonios, setPatrimonios);
        setAlert({ visible: true, title: "Sucesso!", placeholder: message, confirm: false, type: "success" });
        return dados;
      } else {
        setAlert({ visible: true, title: "Atenção!", placeholder: message, confirm: false, type: "warning" });
      }
    } catch (error) {
      console.log(error);
      setAlert({
        type: "error",
        message: "Erro ao buscar equipamentos",
      });
    }
  }

  const searchPatrimonioByEtiquetaId = async (id) => {
    try {
      const response = await apiUser.post(`patrimonio/searchPatrimonioByEtiquetaId`, { id });
      const { success, message, dados } = response.data;
      if (success) {
        return dados;
      } else {
        setAlert({ visible: true, title: "Atenção!", placeholder: message, confirm: false, type: "warning" });
      }
    } catch (error) {
      console.log(error);
      setAlert({
        type: "error",
        message: "Erro ao buscar equipamentos",
      });
    }
  }

  const movimentarPatrimonios = async (movimento) => {
    try {
      const response = await apiUser.post(`patrimonio/movimentarPatrimonios`, movimento);
      const { success, message } = response.data;
      if (success) {
        setAlert({ visible: true, title: "Sucesso!", placeholder: message, confirm: false, type: "success" });
      } else {
        setAlert({ visible: true, title: "Atenção!", placeholder: message, confirm: false, type: "warning" });
      }
      return success;
    } catch (error) {
      console.log(error);
      setAlert({
        type: "error",
        message: "Erro ao buscar equipamentos",
      });
    }
  }

  const listarNotasFiscais = async () => {
    try {
      const response = await apiUser.get(`patrimonio/listarNotasFiscais`);
      const { success, message, dados } = response.data;
      if (success) return dados;
      setAlert({ visible: true, title: "Atenção!", placeholder: message, confirm: false, type: "warning" });
      return [];
    } catch (error) {
      console.log(error);
      setAlert({ visible: true, title: "Erro!", placeholder: "Erro ao listar notas fiscais.", confirm: false, type: "error" });
      return [];
    }
  }

  const excluirNotaFiscal = async (nf, cpf_cnpj, forcar = false) => {
    try {
      const response = await apiUser.post(`patrimonio/excluirNotaFiscal`, { nf, cpf_cnpj, forcar });
      const { success, message } = response.data;
      // Quando há movimentações, o chamador decide o próximo passo (oferecer
      // exclusão forçada) — não dispara alerta automático nesse caso.
      const motivoEspecial = response.data.motivo === MOTIVOS.MOVIMENTACOES_EXISTENTES;
      if (success || !motivoEspecial) {
        setAlert({
          visible: true,
          title: success ? "Sucesso!" : "Atenção!",
          placeholder: message,
          confirm: false,
          type: success ? "success" : "warning"
        });
      }
      return response.data;
    } catch (error) {
      console.log(error);
      setAlert({ visible: true, title: "Erro!", placeholder: "Erro ao excluir nota fiscal.", confirm: false, type: "error" });
      return { success: false };
    }
  }

  const criarPatrimonioNfsByXml = async (xmlData) => {
    try {
      const response = await apiUser.post(`patrimonio/criarPatrimonioNfsByXml`, xmlData);
      const { success, message } = response.data;
      if (success) {
        setAlert({ visible: true, title: "Sucesso!", placeholder: message, confirm: false, type: "success" });

      } else {
        setAlert({ visible: true, title: "Atenção!", placeholder: message, confirm: false, type: "warning" });
      }
      return success;
    } catch (error) {
      console.log(error);
      const detalhe = error?.response?.data?.message || error?.message || "Erro desconhecido";
      setAlert({
        visible: true,
        title: "Erro!",
        placeholder: `Erro ao criar patrimônios da nota fiscal: ${detalhe}`,
        confirm: false,
        type: "error"
      });
      return false;
    }
  }


  function updatePatrimonioState(pat, patrimoniosState, setPats) {
    console.log(pat);
    let pats = [...patrimoniosState];
    let index = pats.findIndex((p) => p.id === pat.id);
    pats[index] = pat;
    setPats(pats);
  }

  async function getAllPatrimoniosEstoque(filtros = {}) {
    try {
      const response = await apiUser.post("patrimonios/estoque", filtros);
      const { data } = response;
      return data.length > 0 ? data : [];
    } catch (error) {
      console.log(error);
      return [];
    }
  }

  const getEstoquePorCliente = async () => {
    try {
      const response = await apiUser.post("/patrimonios/estoque-por-cliente");
      const { success, dados } = response.data;
      if (success) {
        return dados;
      }
      return [];
    } catch (error) {
      console.error("Erro ao buscar estoque por cliente:", error);
      return [];
    }
  };

  const cadastroMassaPatrimonios = async (equipamentosData) => {
    try {
      setPatLoading(true);
      const response = await apiUser.post("patrimonio/cadastroMassaPatrimonios", equipamentosData);
      const { success, message } = response.data;

      if (success) {
        setAlert({
          visible: true,
          title: "Sucesso!",
          placeholder: message || "Equipamentos cadastrados com sucesso!",
          confirm: false,
          type: "success"
        });
        return { success: true, message };
      } else {
        setAlert({
          visible: true,
          title: "Atenção!",
          placeholder: message || "Erro ao cadastrar equipamentos",
          confirm: false,
          type: "warning"
        });
        return { success: false, message };
      }
    } catch (error) {
      console.error('Erro ao cadastrar equipamentos:', error);
      setAlert({
        visible: true,
        title: "Erro!",
        placeholder: "Erro ao cadastrar equipamentos. Tente novamente.",
        confirm: false,
        type: "error"
      });
      return { success: false, message: "Erro interno" };
    } finally {
      setPatLoading(false);
    }
  }

  // async function crossDataPatrimoniosEstoque(pats, grupos) {
  //   try {
  //     const response = await apiUser.post("patrimonios/crossDataEstoque", { pats, grupos });
  //   } catch (error) {
  //     console.log(error);
  //   }
  // }

  useEffect(() => {
    dadosEquipamentos();
  }, []);


  useEffect(() => {
    dadosGrupos();
  }, []);

  return (
    <PatrimonioContext.Provider
      value={{
        marcasByFornecedor,
        modelosByMarca,
        criarMarca,
        criarModelo,
        deleteMarca,
        deleteModelo,
        grupos,
        criarGrupo,
        equipamentos,
        equipamentosByGrupo,
        updateGrupoEquipamentos,
        createPatrimonio,
        buscarPatrimoniosNfs,
        buscarPatrimonios,
        buscarAllPatrimonios,
        patrimonios,
        updatePatrimonioById,
        updatePatrimonioNfsById,
        searchPatrimonioByEtiquetaId,
        movimentarPatrimonios,
        criarPatrimonioNfsByXml,
        patLoading,
        getAllPatrimoniosEstoque,
        getEstoquePorCliente,
        cadastroMassaPatrimonios,
        listarNotasFiscais,
        excluirNotaFiscal,
      }}
    >
      {children}
    </PatrimonioContext.Provider>
  );
};